(function () {
	const triggers = document.querySelectorAll('[class*="tab-switch-trigger-"]');

	if (! triggers.length) {
		return;
	}

	function getTabIndex(el) {
		const match = el.className.match(/tab-switch-trigger-(\d+)/);
		return match ? match[1] : null;
	}

	triggers.forEach(trigger => {
		trigger.addEventListener('click', function () {
			const index = getTabIndex(trigger);
			if (! index) {
				return;
			}

			document.querySelectorAll('[class*="tab-switch-trigger-"]').forEach(t => {
				t.classList.remove('tab-switch-active');
			});
			document.querySelectorAll('[class*="tab-switch-panel-"]').forEach(p => {
				p.classList.remove('tab-switch-active');
			});

			trigger.classList.add('tab-switch-active');
			const panel = document.querySelector('.tab-switch-panel-' + index);
			if (panel) {
				panel.classList.add('tab-switch-active');
			}
		});
	});

})();